import { environment } from "$lib/env"
import { getCookie } from "$lib/utils/cookies"
import type { ITransaction } from "$lib/interfaces/ITransaction"
import type { ITransactionDetails } from "$lib/interfaces/ITransactionDetails"

interface ApiResponse<T> {
  data: T
  error?: string
}

class PaymentService {
  private apiUrl: string

  constructor() {
    this.apiUrl = environment.apiUrl
  }

  private async fetchWithAuth<T>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
    const url = `${this.apiUrl}${endpoint}`
    const headers = new Headers(options.headers)

    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json")
    }

    const token = getCookie("forza_token")
    headers.set("Authorization", `Bearer ${token}`)

    const response = await fetch(url, { ...options, headers })
    const data = await response.json()

    if (!response.ok) {
      return { data: null as T, error: data.message || "An error occurred" }
    }

    return { data }
  }

  async getPaymentOptions(transactionType: "DEPOSIT" | "WITHDRAWAL"): Promise<ApiResponse<ITransaction[]>> {
    return this.fetchWithAuth<ITransaction[]>(`/payment-options?transactionType=${transactionType}`)
  }

  async paymentInit(paymentOptionId: any, data: any): Promise<ApiResponse<ITransaction[]>> {
    return this.fetchWithAuth<ITransaction[]>(`/payment-options/${paymentOptionId}/init`, {
      method: "POST",
      body: JSON.stringify(data),
    })
  }

  async getUserTransaction(orderId: string): Promise<ApiResponse<ITransactionDetails[]>> {
    return this.fetchWithAuth<ITransactionDetails[]>(`/user/transactions/${orderId}`)
  }
}

export const paymentService = new PaymentService()

